module.exports = __webpack_public_path__ + "static/media/off.da260742.png";